import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TeamMemberDetails } from 'src/app/oncall/models/team-member-details';

@Component({
    selector: 'add-team-member-dialog',
    styleUrls: ['./add-team-member-dialog.component.css'],
    templateUrl: 'add-team-member-dialog.component.html',
    standalone: false
})
export class AddTeamMemberDialogComponent {
  selectedMembers: TeamMemberDetails[] = [];
  constructor(
    private dialogRef: MatDialogRef<AddTeamMemberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { members: TeamMemberDetails[] }
  ) { }

  saveTeam(): void {
    this.dialogRef.close(this.selectedMembers);
  }

  close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}